import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './ReturnInfoTile.scss';
import { KeyboardArrowRight } from '@mui/icons-material';
import DateTime from '../library/common/DateTime'
import ProductBadge from '../library/badges/ProductBadge';
import HrbTranslate from '../language/HrbTranslate';
import { useReturnInfoDisplayData } from './hooks/useReturnInfoDisplayDataHook';
import ReturnInfoTileLink from './ReturnInfoTileLink';

const ReturnInfoTile = (props) => {    
    const [productDisplayString, nameDisplayString, linkLocation]
        = useReturnInfoDisplayData(props.return, props.clientId, props.lang);    

    const { id, product, lastModified, isDeleted } = props.return

    return (
        <ReturnInfoTileLink returnId={id} isDeleted={isDeleted} linkLocation={linkLocation}>
            <div className={classnames('columns level return-info-tile', { 'is-deleted': isDeleted })}>
                <div className='column is-1' />
                <div className='column is-1'>
                    <ProductBadge productCode={product} />
                </div>
                <div className={classnames('column', { 'is-5': isDeleted, 'is-8': !isDeleted })}>
                    <p className='p1'>{nameDisplayString}</p>
                    <p className='p1 medium-weight'>{productDisplayString}</p>
                </div>
                {isDeleted &&
                <div className='column is-3'>                    
                    <p className='p2'>
                        <HrbTranslate text='ReturnInfo.Labels.DeletedOn' params={{ DateValue: <DateTime dateAndTime value={lastModified} /> }} />
                    </p>
                </div>
                }
                <div className='column is-1'>
                    <div className='arrow-holder'>
                        <KeyboardArrowRight />
                    </div>
                </div>
                <div className='column is-1' />
            </div>   
            <div className={classnames('columns separator-border', { 'last-item': Boolean(props.lastItem) })}>
                <div className='column is-1' />
                <div className='column is-10'>
                    <hr />
                </div>
                <div className='column is-1' />
            </div>
        </ReturnInfoTileLink>
    )
}

ReturnInfoTile.propTypes = {
    return: PropTypes.object.isRequired,
    clientId: PropTypes.string.isRequired,
    lastItem: PropTypes.bool
}

export default ReturnInfoTile;